import { SVGProps } from 'react';

const FoldedPaperCorner = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="45"
      height="42"
      viewBox="0 0 45 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_9749_47251)">
        <path
          d="M12.75 22.2V4L40.75 30H21.15C18.9222 30 16.7856 29.1782 15.2103 27.7154C13.635 26.2527 12.75 24.2687 12.75 22.2Z"
          fill="url(#paint0_linear_9749_47251)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_9749_47251"
          x="0.75"
          y="0"
          width="44"
          height="42"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4" dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.781673 0 0 0 0 0.781673 0 0 0 0 0.781673 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9749_47251"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_9749_47251"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_9749_47251"
          x1="26.75"
          y1="4"
          x2="26.75"
          y2="30"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EFEFEF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FoldedPaperCorner;
